import React from 'react';
import Icon from '../../../AppIcon';
import Button from '../../../ui/Button';

const ScoutingHeader = ({ 
  isOnline, 
  syncStatus, 
  onSync, 
  onSettings, 
  pendingSubmissions = 0 
}) => {
  return (
    <div className="bg-card border-b border-border p-4">
      <div className="flex items-center justify-between">
        {/* Left Section - Status */}
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <div className={`w-3 h-3 rounded-full ${isOnline ? 'bg-success animate-pulse' : 'bg-warning'}`}></div>
            <span className="text-sm font-medium text-foreground">
              {isOnline ? 'Online' : 'Offline'}
            </span>
          </div>
          
          {syncStatus && (
            <div className="flex items-center space-x-1 text-xs text-muted-foreground">
              <Icon name="RefreshCw" size={12} className={syncStatus === 'syncing' ? 'animate-spin' : ''} />
              <span>{syncStatus === 'syncing' ? 'Syncing...' : 'Synced'}</span>
            </div>
          )}
        </div>

        {/* Right Section - Actions */}
        <div className="flex items-center space-x-2">
          {pendingSubmissions > 0 && (
            <div className="flex items-center space-x-1 bg-warning/10 text-warning px-2 py-1 rounded-md">
              <Icon name="Clock" size={14} />
              <span className="text-xs font-medium">{pendingSubmissions} pending</span>
            </div>
          )}
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onSync}
            disabled={!isOnline || syncStatus === 'syncing'}
            iconName="RefreshCw"
            iconSize={16}
          >
            Sync
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onSettings}
            iconName="Settings"
            iconSize={16}
          >
            Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ScoutingHeader;